import { API_URLS } from "../constants";
import { getRequest, postRequest } from "../../../system/server-call";
import responseHandler from "../../../system/server-response-handler";

const { GROUP, STORE } = API_URLS;

//Getting group details by groupId
const getGroupDetails = (groupId) => {
  return getRequest(`${GROUP.GROUP_PROFILE}/${groupId}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getBrandLocationsByGroupId = (groupId) => {
  return getRequest(`${GROUP.STORES}/${groupId}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getBrandLocationsByGroupsIds = (groupIds) => {
  return postRequest(STORE.GET_STORES_BY_GROUP_IDS, groupIds).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Function to create group
const getGroupPaginatedDetails = (body, groupId) => {
  return postRequest(`${GROUP.PAGINATED_GROUP_PROFILE}/${groupId}`, body).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Exporting functions for other files
export const individualGroupProfileService = {
  getGroupDetails,
  getGroupPaginatedDetails,
  getBrandLocationsByGroupId,
  getBrandLocationsByGroupsIds,
};
